export function LoadingScreen({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="grid min-h-screen place-items-center bg-fh-cream" role="status" aria-live="polite">
      <div className="flex items-center gap-3 text-fh-gray">
        <span
          aria-hidden="true"
          className="h-5 w-5 animate-spin rounded-full border-2 border-current border-r-transparent"
        />
        {label}
      </div>
    </div>
  );
}
